import React from 'react';
import './CircularSelector.css';

/**
 * 7段階の円形セレクター コンポーネント
 * モチベーション・トレンド診断（50010）などで使用される視覚的な選択UI
 */
const CircularSelector = ({
  choices,          // 選択肢の配列
  value,            // 現在選択されている値
  onChange,         // 変更ハンドラー
  name,             // input name属性
  surveyCode        // サーベイコード（逆コーディング処理用）
}) => {
  /**
   * 円をクリックした時の処理
   */
  const handleClick = (index) => {
    const selectedValue = surveyCode === '30010'
      ? 8 - (index + 1)  // 30010の逆コーディングロジック維持
      : index + 1;

    // 既存のonChange関数と互換性を保つためイベントオブジェクトを作成
    onChange({
      preventDefault: () => {},
      target: {
        name: name,
        value: selectedValue,
        type: 'radio'
      }
    });
  };

  /**
   * キーボード操作のハンドリング（アクセシビリティ対応）
   */
  const handleKeyPress = (e, index) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(index);
    }
  };

  /**
   * 円のサイズクラスを取得（段階的なサイズ変化）
   */
  const getSizeClass = (index) => {
    if (index === 0 || index === 6) return 'size-xlarge';   // 1番と7番は最大
    if (index === 1 || index === 5) return 'size-large';    // 2番と6番は大
    if (index === 2 || index === 4) return 'size-medium';   // 3番と5番は中
    if (index === 3) return 'size-small';                    // 4番は最小
    return 'size-medium';
  };

  /**
   * 円の中に表示する文字を取得（1番=A, 7番=B, その他は空）
   * 50030（キャラクター診断）ではA/Bを表示しない
   */
  const getCircleText = (index) => {
    // 50030（キャラクター診断）はA/B表示しない
    if (surveyCode === '50030') return '';

    if (index === 0) return 'A';
    if (index === 6) return 'B';
    return '';
  };

  return (
    <div className="circular-selector">
      <div className="circular-selector-items">
        {choices.map((choice, index) => {
          const itemValue = surveyCode === '30010'
            ? 8 - (index + 1)
            : index + 1;
          const isSelected = value === itemValue;
          const sizeClass = getSizeClass(index);
          const circleText = getCircleText(index);

          return (
            <div
              key={index}
              className="circular-selector-item"
              onClick={() => handleClick(index)}
              onKeyPress={(e) => handleKeyPress(e, index)}
              role="radio"
              aria-checked={isSelected}
              aria-label={`${choice} (${index + 1}番目の選択肢)`}
              tabIndex={0}
            >
              <div className={`circular-selector-circle ${sizeClass} ${isSelected ? 'selected' : ''}`}>
                {circleText && (
                  <span className="circular-selector-letter">{circleText}</span>
                )}
              </div>
              <div className="circular-selector-label">
                {choice}
              </div>
            </div>
          );
        })}
      </div>
      {/* 隠しinput（フォーム送信用） */}
      <input
        type="hidden"
        name={name}
        value={value || ''}
      />
    </div>
  );
};

export default CircularSelector;
